import React from 'react'
import NukaCarousel from 'nuka-carousel'

// css
import '../assets/css/CarrosselNOVO.css'
import '../assets/css/w3School.css'
import '../assets/css/trilha_aprendizado.css'

import CardOferta from './CardOferta'

const Carousel = ({ 
  cursos,
  slidesToShow,
  slidesToScroll,
  wrapAround,
  padding,
  botaoDireito,
  botaoEsquerdo,
  handleAfterSlide
}) => {
  return(
    cursos 
      ?<NukaCarousel
        slidesToShow={slidesToShow} 
        slidesToScroll={slidesToScroll}
        cellAlign="left" 
        wrapAround={wrapAround}
        cellSpacing={20} 
        framePadding={padding}
        style={{ height: '48vh' }}

        renderCenterLeftControls={ 
          botaoEsquerdo 
            ?botaoEsquerdo
              :({ previousSlide }) =>
                <button onClick={previousSlide} style={{ borderStyle: "none", background: "#F2711C" }} >
                  <b className="icon-prev-mobile">&lt;</b>
                </button>
        }

        renderCenterRightControls={ 
          botaoDireito 
            ?botaoDireito
              :({ nextSlide }) =>
                <button onClick={nextSlide} style={{ borderStyle: "none", background: "#F2711C" }}>
                  <b className="icon-next-mobile">&gt;</b>
                </button>
        }

        renderBottomCenterControls={false} 
        afterSlide={handleAfterSlide}
      >
        {
          cursos
            .sort((a,b) => a.ordem - b.ordem)
            .map(curso => <CardOferta curso={curso} />)
        }
      </NukaCarousel>
      :null
  );
}

export default Carousel;